// ---------- เงิน ----------
export const B = (n) => Math.round(Number(n) || 0).toLocaleString('th-TH');

// ---------- วันที่ (ทั้งแอพใช้ date string YYYY-MM-DD เทียบเวลาไทยเสมอ) ----------
export const TH_M = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'];
export const TH_D = ['อา','จ','อ','พ','พฤ','ศ','ส'];

// "วันนี้" ตามเวลาไทย — ห้ามใช้ toISOString().slice (จะเพี้ยนหลัง 17:00)
export function todayISO() {
  const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Bangkok',
    year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  return p; // en-CA ให้ YYYY-MM-DD
}
export const parseD = (s) => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d); };
export const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
export const addD = (s, n) => { const d = parseD(s); d.setDate(d.getDate() + n); return iso(d); };
export const diffDays = (a, b) => Math.round((parseD(a) - parseD(b)) / 864e5);

export const thDate = (s) => { const d = parseD(s); return d.getDate() + ' ' + TH_M[d.getMonth()] + ' ' + String(d.getFullYear() + 543).slice(2); };
export const thDateFull = (s) => { const d = parseD(s); return d.getDate() + ' ' + TH_M[d.getMonth()] + ' ' + (d.getFullYear() + 543); };

// timestamp → เวลาไทย
export const thTime = (ts) => new Date(ts).toLocaleTimeString('th-TH',
  { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Bangkok' });
export const thDateTime = (ts) => {
  const d = new Date(ts);
  const date = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Bangkok',
    year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  return thDate(date);
};

// ---------- product line-art ตามหมวด (placeholder จนกว่าจะต่อรูปจริง) ----------
const ART = {
  'เต็นท์': '<path d="M4 30 L24 8 L44 30 Z"/><path d="M24 8 L24 30"/><path d="M18 30 L24 18 L30 30"/>',
  'ทาร์ป': '<path d="M4 26 L14 12 L34 12 L44 26"/><path d="M14 12 L14 32"/><path d="M34 12 L34 32"/><path d="M4 26 L4 32"/><path d="M44 26 L44 32"/>',
  'แคมป์ไฟ': '<path d="M10 26 L38 26 L34 32 L14 32 Z"/><path d="M24 24 C20 20 22 16 24 12 C26 16 30 18 28 22"/><path d="M18 24 C16 21 17 18 19 16"/>',
  'ครัว': '<rect x="8" y="14" width="32" height="4"/><path d="M12 18 L12 32"/><path d="M36 18 L36 32"/><rect x="18" y="6" width="12" height="8" rx="1"/>',
  'เฟอร์นิเจอร์': '<path d="M10 10 L14 24 L34 24 L38 10"/><path d="M14 24 L12 33"/><path d="M34 24 L36 33"/><path d="M14 24 L34 24"/>',
  'เตา': '<circle cx="24" cy="16" r="7"/><path d="M24 23 L24 30"/><path d="M14 30 L34 30"/><path d="M17 12 L31 12"/>',
  'ตะเกียง': '<path d="M18 10 L30 10 L32 26 L16 26 Z"/><path d="M21 6 L27 6"/><path d="M24 6 L24 10"/><circle cx="24" cy="18" r="3.5"/><path d="M16 26 L16 31 M32 26 L32 31"/>',
};
export function artFor(cat) { return ART[cat] || '<rect x="10" y="10" width="28" height="20"/>'; }

export function fmtSize(b) {
  return b < 1048576 ? Math.round(b / 1024) + ' KB' : (b / 1048576).toFixed(1) + ' MB';
}

// ---------- รายการรหัสชิ้น (A, B, C … แล้วต่อด้วย U27 ตาม rent.fn_next_unit_code) ----------
// เช่าทีละหลายชิ้น รหัสจะยาวจนช่องในใบเช่าตัดบรรทัดและใบไหลไปหน้า 2 —
// ตัวที่ต่อกัน 3 ตัวขึ้นไปจึงย่อเป็นช่วง: A B C D F → "A–D F"
export function unitCodeList(codes) {
  const all = codes || [];
  const letters = all.filter(c => /^[A-Z]$/.test(c)).sort();
  const rest = all.filter(c => !/^[A-Z]$/.test(c)).sort();
  const parts = [];
  for (let i = 0; i < letters.length;) {
    let j = i;
    while (j + 1 < letters.length && letters[j + 1].charCodeAt(0) === letters[j].charCodeAt(0) + 1) j++;
    parts.push(j - i >= 2 ? `${letters[i]}–${letters[j]}` : letters.slice(i, j + 1).join(' '));
    i = j + 1;
  }
  return [...parts, ...rest].join(' ');
}

// ---------- รูปสินค้า (กติกาเดียวกับ POS / StockPoint) ----------
// รูปมิเรอร์อยู่ bucket สาธารณะ zort-products · thumb 200px ทำไว้ล่วงหน้าที่
// _thumbs/w200/<path>.jpg — เสิร์ฟเป็นไฟล์ธรรมดา ไม่ใช่ /render/image เพราะ Supabase
// คิดเงิน transform ต่อรูปต่อเดือน (POS+StockPoint เคยชน 188% เมื่อ ส.ค. 2569)
const OBJ_SEG = '/storage/v1/object/public/zort-products/';
const THUMB_SEG = '/storage/v1/object/public/zort-products/_thumbs/w200/';

function toThumb(url) {
  const i = url.indexOf(OBJ_SEG);
  if (i < 0 || url.includes('?')) return null;
  const path = url.slice(i + OBJ_SEG.length);
  if (!path || path.startsWith('_thumbs/')) return null;
  const enc = path.split('/').map(s => encodeURIComponent(decodeURIComponent(s))).join('/');
  return url.slice(0, i) + THUMB_SEG + enc + '.jpg';
}

// ลำดับที่จะลองโหลด: thumb เล็ก → รูปเต็ม (ถ้า thumb ยังไม่ถูกสร้าง) → หมดแล้วค่อยใช้ลายเส้น
export function imageChain(src) {
  if (!src) return [];
  const thumb = toThumb(src);
  return thumb ? [thumb, src] : [src];
}
